import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Dialog, DialogContent, DialogActions, DialogTitle, TextField } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function FileEditDialog(props) {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'), { noSsr: true });

  const [fileChanges, setFileChanges] = React.useState({});

  const handleChange = (event) => {
    fileChanges[event.target.name] = event.target.value;
    setFileChanges(fileChanges);
  };

  return (
    <Dialog className={classes.root} open={props.open} fullScreen={fullScreen}>
      <DialogTitle>Edit File</DialogTitle>
      <DialogContent>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            let elem: any = document.activeElement;
            elem?.blur();
            if (props.save) props.save(fileChanges);
          }}
        >
          <TextField
            name={'fileNickname'}
            label={'File Name'}
            id={props.file?.id + '_fileName'}
            onBlur={handleChange}
            type='text'
            defaultValue={props.file?.fileNickname}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props?.close()} color='primary'>
          Cancel
        </Button>
        <Button onClick={() => props?.save(fileChanges)} color='primary'>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
